const PERMISSIONS = {
  // ─── Enrollment / biometric admin (added 2026-04-24, CR-fix critical-security-bugs) ───
  // Gates the QR-token issuance UI at /settings/enrollment. Previously open to
  // every authenticated user (Codex CRITICAL). Backend MUST also enforce the
  // same permission on the issuance endpoint — frontend gating alone is not
  // sufficient.
  MANAGE_ENROLLMENT: "manage_enrollment",

  ADD_TASK: "add_task",
  VIEW_TASK: "view_task",
  EDIT_TASK: "edit_task",
  DELETE_TASK: "delete_task",
  EXPORT_TASK: "export_task",
  ADD_JOB: "add_job",
  VIEW_JOB: "view_job",
  // CR-2026-GATE-OVERRIDE (2026-10-14): Admin, CEO, Operations Manager request; Quality Manager, QCI co-sign.
  REQUEST_GATE_OVERRIDE: "request_gate_override",
  COSIGN_GATE_OVERRIDE: "cosign_gate_override",
  // CR-2026-CONTRACT-REVIEW (2026-10-15): F1.6.0 contract & spec review
  VIEW_CONTRACT_REVIEW: "view_contract_review",
  EDIT_CONTRACT_REVIEW: "edit_contract_review",
  SIGN_CONTRACT_REVIEW: "sign_contract_review",
  CONFIGURE_CONTRACT_REVIEW: "configure_contract_review",
  // CR-2026-QDP (2026-10-14)
  VIEW_QDP: "view_qdp",
  BUILD_QDP: "build_qdp",
  REVIEW_QDP: "review_qdp",
  APPROVE_QDP: "approve_qdp",
  EDIT_JOB: "edit_job",
  DELETE_JOB: "delete_job",
  EXPORT_JOB: "export_job",
  ADD_INVENTORY: "add_inventory",
  VIEW_INVENTORY: "view_inventory",
  EDIT_INVENTORY: "edit_inventory",
  DELETE_INVENTORY: "delete_inventory",
  EXPORT_INVENTORY: "export_inventory",
  ADD_USER: "add_user",
  VIEW_USER: "view_user",
  EDIT_USER: "edit_user",
  DELETE_USER: "delete_user",
  EXPORT_USER: "export_user",
  ADD_ROLE: "add_role",
  VIEW_ROLE: "view_role",
  // ADR 0004 (2026-09-20): Apple TV floor board display credentials. Seeded to Admin only.
  MANAGE_DISPLAY_DEVICES: "manage_display_devices",
  EDIT_ROLE: "edit_role",
  DELETE_ROLE: "delete_role",
  EXPORT_ROLE: "export_role",
  ADD_PERMISSION: "add_permission",
  VIEW_PERMISSION: "view_permission",
  EDIT_PERMISSION: "edit_permission",
  DELETE_PERMISSION: "delete_permission",
  EXPORT_PERMISSION: "export_permission",
  VIEW_CONTACT: "view_contact",
  ADD_CONTACT: "add_contact",
  EXPORT_CONTACT: "export_contact",
  EDIT_CONTACT: "edit_contact",
  DELETE_CONTACT: "delete_contact",
  ADD_PURCHASE: "add_purchase",
  EDIT_PURCHASE: "edit_purchase",
  DELETE_PURCHASE: "delete_purchase",
  VIEW_PURCHASEDETAIS: "view_purchasedetails",
  ADD_PURCHASEITEM: "add_purchaseitem",
  ADD_Company: "add_company",
  Edit_Company: "edit_company",
  Delete_Company: "delete_company",
  VIEW_VENDOR: "view_vendor",
  ADD_VENDOR: "add_vendor",
  EDIT_VENDOR: "edit_vendor",
  DELETE_VENDOR: "delete_vendor",
  APPROVE_VENDOR: "approve_vendor",
  SUSPEND_VENDOR: "suspend_vendor",
  REMOVE_VENDOR_FROM_AVL: "remove_vendor_from_avl",
  RATE_VENDOR: "rate_vendor",
  VIEW_COMPANY: "view_company",
  Detail_Job: "detail_job",
  Add_Fabricated_Items: "add_fabricated_items",
  Update_Fabricated_Items: "update_fabricated_items",
  ADD_SEQUENCE: "add_sequence",
  DELETE_SEQUENCE: "delete_sequence",
  VIEW_SEQUENCE: "view_sequence",
  EDIT_SEQUENCE: "edit_sequence",
  COLLABORATE_ON_MICROSOFT_WHITEBOARD: "collaborate_on_microsoft_whiteboard",
  Make_Call: "make_call",
  Download_Diagram: "download_diagram",
  BIll_of_Lading: "view_bol",
  // Heat Management & Material Traceability
  VIEW_HEAT: "view_heat",
  ADD_HEAT: "add_heat",
  RELEASE_HEAT: "release_heat",
  DELETE_HEAT: "delete_heat",
  // Release Packages (Engineering Control)
  VIEW_RELEASE_PACKAGE: "view_release_package",
  ADD_RELEASE_PACKAGE: "add_release_package",
  EDIT_RELEASE_PACKAGE: "edit_release_package",
  DELETE_RELEASE_PACKAGE: "delete_release_package",
  // Kiosk / Operator View
  VIEW_KIOSK: "view_kiosk",
  // Reports
  VIEW_REPORTS: "view_reports",
  // QA / NCR
  VIEW_NCR: "view_ncr",
  ADD_NCR: "add_ncr",
  EDIT_NCR: "edit_ncr",
  DELETE_NCR: "delete_ncr",
    // WeldAssure Document Management
    VIEW_WELDASSURE: "view_weldassure",
    // Document Upload
    VIEW_DOCUMENTS: "view_documents",
  CLOSE_NCR: "close_ncr",
  // S-4 (2026-09-29): Admin and Quality Manager approve WPS / PQR / WQTR.
  APPROVE_WELD_PROCEDURE: "approve_weld_procedure",
  // CR-2026-WELD-PERMS (2026-10-15): the server checks these live on the welding write routes.
  // Record weld: Admin, Shop Foreman, Quality Manager, QCI. Record NDE result (plan, accept, reject): Quality Manager, QCI.
  // Void weld or NDE record: Quality Manager.
  RECORD_WELD: "record_weld",
  // S-16b / CR-2026-NDE-REG: Admin and Quality Manager record welder and NDE technician certificates and change their status.
  MANAGE_WELDER_QUALIFICATIONS: "manage_welder_qualifications",
  RECORD_NDE_RESULT: "record_nde_result",
  VOID_WELD_RECORD: "void_weld_record",
  // S-61 (2026-10-06): Admin and Quality Manager add, edit and delete calibration catalog entries.
  // The server enforces it (POST/PUT/DELETE /api/calibration/instruments).
  MANAGE_CALIBRATION_CATALOG: "manage_calibration_catalog",
  // S-71 (2026-10-07): Admin, Quality Manager and Quality Control Inspector add calibration units,
  // record calibration events and take units out of service. The server enforces it.
  MANAGE_CALIBRATION: "manage_calibration",
  // CR-2026-ERECTOR-E1 (2026-10-13): AISC 207-25 §5.12.6 erection plan.
  VIEW_ERECTION: "view_erection",
  EDIT_ERECTION_PLAN: "edit_erection_plan",
  REVIEW_ERECTION_PLAN: "review_erection_plan",
  RELEASE_ERECTION_PLAN: "release_erection_plan",
  // CR-2026-ERECTOR-E2 (2026-10-13): field erection records.
  RECORD_FIELD_ERECTION: "record_field_erection",
  VOID_FIELD_ERECTION: "void_field_erection",
  // CR-2026-ERECTOR-E3 (2026-10-13): endorsement evidence (§5.3.1-§5.3.3).
  RECORD_ENDORSEMENT_EVIDENCE: "record_endorsement_evidence",
  REVIEW_ENDORSEMENT_EVIDENCE: "review_endorsement_evidence",
  // CR-2026-ERECTOR-E4 (2026-10-13): field coating (§5.12.3-§5.12.4).
  EDIT_ERECTOR_COATING_PROCEDURE: "edit_erector_coating_procedure",
  APPROVE_ERECTOR_COATING_PROCEDURE: "approve_erector_coating_procedure",
  RECORD_FIELD_COATING: "record_field_coating",
  // CR-2026-ERECTOR-E5 (2026-10-13): approval to erect + equipment inspections.
  RECORD_ERECTION_START: "record_erection_start",
  ACCEPT_ERECTION_START: "accept_erection_start",
  RECORD_EQUIPMENT_INSPECTION: "record_equipment_inspection",
};

export default PERMISSIONS;
